import React, { FunctionComponent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Layout from '../../containers/Layout';
import Button from '../../components/Button';
import { useOrder } from '../../hooks/order/useOrder';
import Payment from './components/Payment';
import { useReviewPaymentGtm } from '../../hooks/gtm/reviewPayment/useReviewPaymentGtm';
import { getFingerprint } from '../../utils/fingerprint.util';
import { useAnalyzeSession } from '../../hooks/session/useAnalyzeSession';

const ReviewPayment: FunctionComponent = () => {
  const {
    order,
    loading,
    getOrderByIdAndDocument,
    confirmLoading,
    confirmPayment,
  } = useOrder();

  const { isLoading, analyze } = useAnalyzeSession();

  const { id, document } = useParams<{ id: string; document: string }>();

  useEffect(() => {
    getOrderByIdAndDocument(id, document);
  }, [id]);

  const { sendDataToGtm } = useReviewPaymentGtm();

  useEffect(() => {
    if (order) {
      sendDataToGtm(order);
      analyze(id, document);
    }
  }, [order]);

  return (
    <Layout
      title="Resumo do pagamento"
      dark
      loading={loading}
      overContent={
        <Button
          data-cy='confirm-payment-button'
          loading={(confirmLoading || isLoading)}
          onClick={() => {
            confirmPayment(
              id,
              window.location.hash.replace('#encrypted=', ''),
              getFingerprint(),
            );
          }}
          theme="SUCCESS"
        >
          Concluir Pagamento
        </Button>
      }
    >
      {order && <Payment order={order} />}
    </Layout>
  );
};

export default ReviewPayment;
